'use strict';

angular.module('atex.aceui.service').factory('WorkspaceService',
['$q', '$rootScope', 'AuthenticationService', 'ApplicationConfigurationService',

  function($q, $rootScope, AuthenticationService, ApplicationConfigurationService) {
    var serviceHandler = undefined;

    var handler = function() {
      if (serviceHandler !== undefined) {
        return $q.when(serviceHandler);
      }

      return ApplicationConfigurationService.getServiceConfigurationFor('WorkspaceService').then(function(configuration) {
        var serviceUrl = atex.aceui.ServiceUtils.calculateServiceUrl(configuration, 'content/workspace');

        var serviceSettings = { customQ: atex.aceui.AngularUtils.applyingQ($q, $rootScope), cacheBusting: atex.aceui.BrowserUtils.isSafariBrowser() };
        serviceHandler = atex.aceui.service.WorkspaceService(serviceUrl, serviceSettings);

        return serviceHandler;
      });
    };

    return {
      /**
       * Wraps atex.aceui.service.WorkspaceService.get with an authentication
       * guard (provided by AuthenticationService.callWithAuthentication).
       *
       * See documentation for atex.aceui.service.WorkspaceService.get.
       * See documentation for AuthenticationService.callWithAuthentication.
       */
      getContent: function(transferInfo) {
        return AuthenticationService.callWithAuthentication(function(currentUser) {
          return handler().then(function(serviceHandler) {
            return serviceHandler.getContent(_.extend(transferInfo, { authToken: currentUser.token }));
          });
        });
      },

      /**
       * Wraps atex.aceui.service.WorkspaceService.create with an authentication
       * guard (provided by AuthenticationService.callWithAuthentication).
       *
       * See documentation for atex.aceui.service.WorkspaceService.create.
       * See documentation for AuthenticationService.callWithAuthentication.
       */
      createContent: function(transferInfo) {
        return AuthenticationService.callWithAuthentication(function(currentUser) {
          return handler().then(function(serviceHandler) {
            return serviceHandler.createContent(_.extend(transferInfo, { authToken: currentUser.token }));
          });
        });
      },

      /**
       * Wraps atex.aceui.service.WorkspaceService.update with an authentication
       * guard (provided by AuthenticationService.callWithAuthentication).
       *
       * See documentation for atex.aceui.service.WorkspaceService.update.
       * See documentation for AuthenticationService.callWithAuthentication.
       */
      updateContent: function(transferInfo) {
        return AuthenticationService.callWithAuthentication(function(currentUser) {
          return handler().then(function(serviceHandler) {
            return serviceHandler.updateContent(_.extend(transferInfo, { authToken: currentUser.token }));
          });
        });
      },

      /**
       * Wraps atex.aceui.service.WorkspaceService.delete with an authentication
       * guard (provided by AuthenticationService.callWithAuthentication).
       *
       * See documentation for atex.aceui.service.WorkspaceService.delete.
       * See documentation for AuthenticationService.callWithAuthentication.
       */
      deleteContent: function(transferInfo) {
        return AuthenticationService.callWithAuthentication(function(currentUser) {
          return handler().then(function(serviceHandler) {
            return serviceHandler.deleteContent(_.extend(transferInfo, { authToken: currentUser.token }));
          });
        });
      },

      /**
       * Wraps atex.aceui.service.WorkspaceService.promote with an authentication
       * guard (provided by AuthenticationService.callWithAuthentication).
       *
       * See documentation for atex.aceui.service.WorkspaceService.promote.
       * See documentation for AuthenticationService.callWithAuthentication.
       */
      promoteContent: function(transferInfo) {
        return AuthenticationService.callWithAuthentication(function(currentUser) {
          return handler().then(function(serviceHandler) {
            return serviceHandler.promoteContent(_.extend(transferInfo, { authToken: currentUser.token }));
          });
        });
      },

      /**
       * Wraps atex.aceui.service.WorkspaceService.clear with an authentication
       * guard (provided by AuthenticationService.callWithAuthentication).
       *
       * See documentation for atex.aceui.service.WorkspaceService.clear.
       * See documentation for AuthenticationService.callWithAuthentication.
       */
      clearWorkspace: function(transferInfo) {
        return AuthenticationService.callWithAuthentication(function(currentUser) {
          return handler().then(function(serviceHandler) {
            return serviceHandler.clear(_.extend(transferInfo, { authToken: currentUser.token }));
          });
        });
      }
    };
  }
]);
